export const categories = [
  { name: "Home", icon: <i className="bi bi-house"></i> },
  { name: "Trending", icon: <i className="bi bi-fire"></i> },
  { name: "Shopping", icon: <i className="bi bi-cart"></i> },
  { name: "Music", icon: <i className="bi bi-music-note-list"></i> },
  { name: "Films", icon: <i className="bi bi-film"></i> },
  { name: "Live", icon: <i className="bi bi-cast"></i> },
  { name: "Gaming", icon: <i className="bi bi-controller"></i> },
  { name: "News", icon: <i className="bi bi-newspaper"></i> },
  { name: "Sports", icon: <i className="bi bi-bicycle"></i> },
  { name: "Learning", icon: <i className="bi bi-book"></i> },
  { name: "Fashion", icon: <i className="bi bi-heart"></i> },
];

export const demoThumbnailUrl = "https://i.ibb.co/G2L2Gwp/API-Course.png";
export const demoChannelUrl = "/channel/UCmXmlB4-HJytD7wek0Uo97A";
export const demoVideoUrl = "/video/GDa8kZLNhJ4";
export const demoChannelTitle = "JavaScript Mastery";
export const demoVideoTitle =
  "Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI";
export const demoProfilePicture =
  "http://dergipark.org.tr/assets/app/images/buddy_sample.png";
